// src/lib/naranjaPlusModal.ts
// ─────────────────────────────────────────────────────────────
// MODAL GLOBAL DE "NARANJA PLUS REQUERIDO"
//
// Cualquier parte de la app puede pedir el modal con `requireNaranjaPlus(motivo)`.
// El componente <NaranjaPlusRequiredModal /> (montado en la raíz) lo escucha.
// Solo aparece si la suscripción NO está activa (evita molestias al suscriptor).
// ─────────────────────────────────────────────────────────────

import { getLocalSubscriptionState } from '@/lib/naranjaPlus';
import { NARANJA_PLUS_DEV_OVERRIDE } from '@/lib/naranjaPlusRules';

type Listener = (motivo?: string) => void;

const listeners = new Set<Listener>();

/** Texto oficial del modal. */
export const NARANJA_PLUS_MODAL_TEXT =
  '🍊 Esta función requiere Naranja Plus. Actívalo por $50.000 COP/mes (500 coins) y obtén sincronización multi-dispositivo, respaldo en la nube y tienda digital.';

/** Muestra el modal (si Naranja Plus no está activo). */
export const requireNaranjaPlus = async (motivo?: string): Promise<boolean> => {
  // 🛠️ Desarrollo: nunca se bloquea una función por Naranja Plus.
  if (NARANJA_PLUS_DEV_OVERRIDE) return false;

  try {
    const state = await getLocalSubscriptionState();
    if (state.isActive) return false; // ya es suscriptor: no se interrumpe
  } catch {
    /* si no se puede verificar, se muestra igual */
  }
  listeners.forEach(fn => fn(motivo));
  return true;
};

/** Fuerza el modal sin comprobar la suscripción. */
export const forceNaranjaPlusModal = (motivo?: string): void => {
  listeners.forEach(fn => fn(motivo));
};

/** Suscripción al modal (lo usa el componente). */
export const onNaranjaPlusRequired = (fn: Listener): (() => void) => {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
};
